/* eslint no-param-reassign: "off" */
import router from '@/routes/router'
import {
  SET_EDIT_STATE,
  SET_EDITABLE_ACTIVE_STATE,
  SET_EDIT_UNSAVED,
  SET_SAVING_STATE,
  SET_RECENTLY_SAVED_STATE,
} from '@/state/mutation-types'
import { SET_EDIT_SAVING_STATE } from '@/state/action-types'

const editStore = {
  strict: import.meta.env.VITE_APP_ENV !== 'production',
  state: {
    on: false,
    saving: false,
    recentlySaved: false,
    activeEditable: false,
    unsaved: [],
  },
  getters: {
    // A getter specifically made to let components watch and react to changes
    watchEdit: (state) => state,
  },
  mutations: {
    // Internal saving mutations
    [SET_SAVING_STATE](state, isSaving) {
      state.saving = isSaving
    },
    [SET_RECENTLY_SAVED_STATE](state, isRecentlySaved) {
      state.recentlySaved = isRecentlySaved
    },

    [SET_EDIT_STATE](state, set) {
      // We try to convert different types into a proper boolean
      const n = Number(set)
      if (Number.isNaN(n)) {
        if (set === 'False') {
          state.on = false
        } else {
          state.on = Boolean(set)
        }
      } else {
        state.on = Boolean(n)
      }

      router
        .push({
          path: window.location.pathname,
          query: { ...router.currentRoute.value.query, edit: state.on ? 1 : 0 },
        })
        .catch((err) => {})
    },

    // Sets the variable that dictates weather or not we are allowed to edit
    [SET_EDITABLE_ACTIVE_STATE](state, isActive) {
      state.activeEditable = !!isActive
    },

    // If edits have been made, but not saved, set this
    [SET_EDIT_UNSAVED](state, set) {
      if (set) {
        state.unsaved.push(set)
      } else {
        state.unsaved.pop()
      }

      // This is to ensure that some local js outside of vue can also access this method (See legacy code)
      window.unsaved = state.unsaved.length !== 0
    },
  },
  actions: {
    [SET_EDIT_SAVING_STATE]({ commit, state }, newSavingState) {
      const previousSavingState = state.saving
      if (previousSavingState === true && newSavingState === false) {
        commit(SET_RECENTLY_SAVED_STATE, true)
        // This timeout may seem arbitrary but it is used to add animations that react when we recently saved information
        setTimeout(() => {
          commit(SET_RECENTLY_SAVED_STATE, false)
        }, 6000)
      }
      commit(SET_SAVING_STATE, newSavingState)
    },
  },
}

export default editStore
